module.exports = __webpack_public_path__ + "files/a96337c6a515c58c45a7d1a139364485.png";